module.exports = __webpack_public_path__ + "img/COMBO SPIRAL PURPLE.8e44c08.svg";